<template>
  <ReportPanel>
    <h6 class="q-mt-md">Please select the financial year and quarter you wish to generate the report for.</h6>

    <FinancialYearQuarterSelector
      :selected-financial-year="selectedFinancialYear"
      :selected-quarter="selectedQuarter"
      :financial-years="financialYears"
      :quarter-options="quarterOptions"
      :show-quarter="true"
      @update:selected-financial-year="selectedFinancialYear = $event"
      @update:selected-quarter="selectedQuarter = $event"
    />

    <q-btn
      :loading="loading"
      label="Generate Outcomes Report"
      class="full-width"
      color="secondary"
      no-caps
      @click="generateReport"
    />
  </ReportPanel>
</template>

<script>
import api from "@/services/api/api";
import notify from "@/services/util/notify";
import { promptDownload } from "@/services/util/file";
import FinancialYearQuarterSelector from "./FinancialYearQuarterSelector.vue";
import ReportPanel from "./ReportPanel.vue";

export default {
  name: "KpiReportPanel",
  components: {
    FinancialYearQuarterSelector,
    ReportPanel
  },
  props: {
    financialYears: {
      type: Array,
      required: true
    },
    quarterOptions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      selectedQuarter: null,
      selectedFinancialYear: 2024
    }
  },
  methods: {
    async generateReport() {
      this.loading = true;

      try {
        if (this.selectedQuarter == null) {
          notify.error("Please select a quarter");
          return;
        }

        const report = await api.reports.generateOutcomesReport(this.selectedQuarter, this.selectedFinancialYear);
        promptDownload(report, `Outcomes Reporting Quarter FY${this.selectedFinancialYear} Q${this.selectedQuarter}.xlsx`);
      } catch (error) {
        console.error(error);
        notify.error("There was an issue generating your outcomes report.");
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
